import { DateTime } from "luxon";

const DataFormatterPlugin = {
    install(Vue) {
        Vue.prototype.$formatData = (result, timePeriod) => {
            const format = this.formats[timePeriod];
            const aggregatedBy = result.data.aggregatedBy || "";
            const data = result.data.data;
            if (aggregatedBy.toLowerCase() === "week") {
                return this.formatWeekData(data);
            } else if (timePeriod.toLowerCase() === "lastmonth" && DateTime.fromISO(Object.keys(data)[0]).isValid) {
                return this.formatDataByLastMonth(data);
            }

            if (DateTime.fromISO(Object.keys(data)[0]).isValid) {
                return this.formatDataDefault(data, format);
            }

            return this.formatDataDefault(data);
        };
    },
    formats: {
        ["today"]: "H",
        ["yesterday"]: "H",
        ["dayBeforeYesterday"]: "H",
        ["thisWeek"]: "ccccc",
        ["lastWeek"]: "ccccc",
        ["thisMonth"]: "d",
        ["last28Days"]: "d",
        ["lastMonth"]: "W",
        ["thisYear"]: "LLLLL",
        ["lastYear"]: "LLLLL",
        ["custom"]: "d",
    },
    formatDate(date, format) {
        return DateTime.fromISO(date ?? DateTime.local().toString())
            .setLocale("en-US")
            .toFormat(format ?? "d");
    },
    formatDataByLastMonth(data) {
        const graphData = [];

        for (const key in data) {
            const isMonday = DateTime.fromISO(key).weekday === 1;
            graphData.push({
                x: isMonday ? "Week " + DataFormatterPlugin.formatDate(key, DataFormatterPlugin.formats.lastMonth) : "",
                y: data[key],
            });
        }

        return graphData;
    },
    formatDataDefault(data, format) {
        const graphData = [];

        for (const key in data) {
            graphData.push({
                x: format ? this.formatDate(key, format) : key,
                y: data[key],
            });
        }

        return graphData;
    },
    formatWeekData(data) {
        const graphData = [];
        for (const key in data) {
            const date = key.split("-");

            // Its possible that week 53/52 continues in the next year
            // When that happens that data will be set to week 0
            // If we have a week 0 in our data we need to set it to week 53 or 52
            // If the previous year was a leap year set week 0 to week 53
            if (date[1] == "0") {
                const isLeap = new Date(parseInt(date[0]) - 1, 1, 29).getDate() === 29;
                date[1] = isLeap ? "53" : "52";
            }
            graphData.push({
                x: "Week " + date[1],
                y: data[key],
            });
        }

        return graphData;
    },
};

export default DataFormatterPlugin;
